import React from 'react';
import classNames from 'classnames';
import css from './Badge.css';

const Badge = ({ children, variant, isFullWidth = false, className }) => {
  const classes = classNames(
    css.badge,
    {
      [css.stolen]: variant === 'stolen',
      [css.fullWidth]: isFullWidth,
    },
    className
  );

  return (
    <div className={classes}>
      {children}
    </div>
  );
};

export default Badge;